import { render, staticRenderFns } from "./KPI's.vue?vue&type=template&id=44cfef7c"
import script from "./KPI's.vue?vue&type=script&lang=js"
export * from "./KPI's.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports